import { motion } from "framer-motion";
import { Leaf, HeartHandshake, ShieldCheck, Clock } from "lucide-react";

const values = [
    {
        icon: Leaf,
        title: "Evidence-first Care",
        text: "Protocols grounded in modern dermatology and dentistry research.",
    },
    {
        icon: HeartHandshake,
        title: "Unhurried Consultations",
        text: "We take the time to understand your goals, concerns and lifestyle.",
    },
    {
        icon: ShieldCheck,
        title: "Sterile & Safe",
        text: "Medical-grade hygiene and single-use instruments where it matters.",
    },
    {
        icon: Clock,
        title: "Evening Hours",
        text: "Open 11 AM to 9 PM — built around your day.",
    },
];

export default function About() {
    return (
        <section
            id="about"
            className="py-24 md:py-32 relative"
            data-testid="about-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.6 }}
                        className="lg:col-span-5"
                    >
                        <span className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B] font-medium">
                            — About Mirrari
                        </span>
                        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-[#1A221F] mt-4 leading-[1.1] tracking-tight">
                            A clinic that feels <em className="italic text-[#3B5249]">more like home</em>,
                            built on clinical excellence.
                        </h2>
                        <p className="text-base md:text-lg text-[#4A5D54] leading-relaxed mt-6">
                            Mirrari Clinic is Amravati's premium destination for Dermatology,
                            Venereology & Leprosy (DVL) and comprehensive Dental care. Under
                            the lead of Dr. Hitesh Khatri and Dr. Chitra Sachdev, we combine
                            warm hospitality with precise, specialist-led treatment plans.
                        </p>
                        <p className="text-base text-[#4A5D54] leading-relaxed mt-4">
                            Whether you are addressing acne, pigmentation, hair loss,
                            root-canal care or a cosmetic smile makeover — every visit is
                            designed around your comfort, privacy and results.
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0 }}
                        whileInView={{ opacity: 1 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8 }}
                        className="lg:col-span-7 grid sm:grid-cols-2 gap-5"
                    >
                        {values.map((v, i) => (
                            <motion.div
                                key={v.title}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.5, delay: i * 0.1 }}
                                className="bg-white rounded-3xl p-7 border border-[#E8E6E1] shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)] transition-all duration-300"
                                data-testid={`about-value-${i}`}
                            >
                                <div className="w-11 h-11 rounded-2xl bg-[#F3F1EC] flex items-center justify-center mb-5">
                                    <v.icon className="w-5 h-5 text-[#3B5249]" />
                                </div>
                                <h3 className="font-display text-xl text-[#1A221F] font-medium">
                                    {v.title}
                                </h3>
                                <p className="text-sm text-[#4A5D54] mt-2 leading-relaxed">
                                    {v.text}
                                </p>
                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
